export const monthsList = [
  'ינואר',
  'פברואר',
  'מרץ',
  'אפריל',
  'מאי',
  'יוני',
  'יולי',
  'אוגוסט',
  'ספטמבר',
  'אוקטובר',
  'נובמבר',
  'דצמבר',
];

export const numberToMonthText = (month: number) => {
  return monthsList[month] ?? '';
};

export const monthTextToNumber = (month: string) => {
  const monthIndex = monthsList.indexOf(month);
  return monthIndex;
};

/** Converts 1-based month (1=January) from payslip API to Hebrew text */
export const payslipMonthToText = (month: number) => {
  return monthsList[month - 1] ?? '';
};

/** Converts Hebrew month name to 1-based month number for payslip API */
export const monthTextToPayslipMonth = (month: string) => {
  const monthIndex = monthsList.indexOf(month);
  return monthIndex >= 0 ? monthIndex + 1 : -1;
};
